
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Sanglitopunecab() {



  const cardData =
  {
    keyword: 'Sangli to Pune Cab',
    heading: 'SHREE Tours & Travels: Sangli to Pune Cab',
    headingDescription: 'SHREE Tours & Travels offers a reliable Sangli to Pune Cab service, ensuring a smooth and comfortable journey. Whether you are traveling for business, leisure, or a return trip home, our well-maintained Cabs and professional drivers provide a hassle-free experience. With on-time pickups, flexible booking options and affordable fares, we guarantee a safe and convenient ride. Choose SHREE Tours & Travels for a stress-free Sangli to Pune travel experience.',

    top: 'Top Places to Visit in Pune with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in Pune, Shaniwar Wada was once the seat of the Peshwas of the Maratha Empire. Built in 1732, this grand structure features intricate wooden architecture, massive gates and the famous 'Delhi Darwaza.' It is surrounded by gardens and fountains, making it a great spot for history enthusiasts. The light and sound show in the evening narrates the fort's rich history, adding to the experience."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is an architectural masterpiece and a symbol of India's freedom struggle. It served as a prison for Mahatma Gandhi and other freedom fighters during the Quit India Movement. The palace features Italian arches, sprawling gardens and a museum housing personal belongings of Mahatma Gandhi, making it a must-visit for history and heritage lovers."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Perched atop a hill, Sinhagad Fort is one of Pune’s most famous trekking destinations. This historic fortress, associated with the Maratha warrior Tanaji Malusare, offers breathtaking views of the Sahyadri mountains. Visitors can explore the ancient ruins, enjoy local delicacies like 'pithla bhakri,' and experience the fort’s rich history while trekking through its scenic trails."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of Pune’s most revered temples, Dagdusheth Halwai Ganpati Temple is dedicated to Lord Ganesha. Known for its grand Ganesh idol adorned with gold ornaments, the temple attracts thousands of devotees daily. The temple’s annual Ganesh festival is a grand spectacle, featuring magnificent decorations, cultural performances and a spiritual ambiance."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "A fascinating museum housing over 20,000 artifacts, the Raja Dinkar Kelkar Museum showcases a diverse collection of sculptures, paintings, musical instruments and everyday objects from India’s past. The museum is particularly known for its replica of the Mastani Mahal, which provides a glimpse into the royal lifestyle of the Peshwas."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "Carved out of a single rock in the 8th century, the Pataleshwar Cave Temple is dedicated to Lord Shiva. This ancient temple, featuring massive stone pillars and intricate carvings, is a peaceful retreat amidst Pune’s bustling city life. The temple’s unique architecture and serene atmosphere make it a hidden gem for history and spirituality seekers."
    },
    {
        "title": "Pashan Lake",
        "description": "Pashan Lake is a beautiful artificial lake, ideal for nature lovers and bird watchers. Surrounded by lush greenery, the lake serves as a habitat for various migratory birds. The walking track along the lake makes it a perfect spot for morning walks, photography and peaceful relaxation away from the city’s hustle."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-renowned spiritual center promoting meditation and wellness. Visitors can experience a range of meditation techniques, yoga sessions and rejuvenation therapies. The ashram's lush gardens, serene atmosphere and international community make it a unique place for self-discovery and relaxation."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal is a historic site closely associated with Chhatrapati Shivaji Maharaj, as it was his childhood residence. Though rebuilt, the palace features paintings and exhibits depicting Shivaji’s life and achievements. The site is of great historical importance and offers insights into the Maratha legacy."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Situated on the outskirts of Pune, Khadakwasla Dam is a popular picnic spot offering scenic views and a refreshing escape. The dam is a great place for photography, evening walks and enjoying street food like corn and chai. The nearby Sinhagad Fort and Panshet Dam make it a perfect getaway for adventure seekers and nature lovers."
    }
],  
    
            
"services": [
    {
      "name": "Sangli to Pune Taxi",
      "description": "Travel comfortably with our Sangli to Pune taxi service. Our well-maintained vehicles and professional drivers ensure a smooth, hassle-free and timely journey, whether you're traveling for business or leisure."
    },
    {
      "name": "Sangli to Pune Cab Service",
      "description": "Looking for a reliable Cab service from Sangli to Pune? We offer affordable one-way and round-trip options, with comfortable vehicles and experienced drivers ensuring a smooth and stress-free ride."
    },
    {
      "name": "Sangli to Pune One-Way Taxi",
      "description": "Book a one-way taxi from Sangli to Pune for a convenient and cost-effective ride. Our service ensures a smooth journey, with no hidden charges and comfortable seating throughout the trip."
    },
    {
      "name": "Sangli to Pune Round Trip Cab",
      "description": "Planning a round trip from Sangli to Pune? Our round-trip Cab service offers flexibility and convenience, with well-maintained cars and professional drivers to ensure a pleasant experience throughout your journey."
    },
    {
      "name": "Affordable Sangli to Pune Cab",
      "description": "Get affordable yet reliable Cab services from Sangli to Pune. We offer budget-friendly options without compromising on comfort or safety, ensuring an economical and smooth travel experience."
    },
    {
      "name": "Private Taxi for Pune from Sangli",
      "description": "Book a private taxi from Sangli to Pune for a personalized travel experience. Enjoy privacy, comfort and flexibility with a Cab tailored to your schedule and preferences."
    },
    {
      "name": "Pune Tour from Sangli by Cab",
      "description": "Explore Pune with our convenient and comfortable Cab service from Sangli. We provide customized tours, allowing you to explore the best attractions in Pune while enjoying a comfortable ride with experienced drivers."
    },
    {
      "name": "Group Travel from Sangli to Pune",
      "description": "Traveling with a group? Our spacious Cabs are ideal for group travel from Sangli to Pune. Whether it's a family outing or a corporate trip, we provide comfortable seating and ample space for luggage."
    },
    {
      "name": "Book Sangli to Pune Car",
      "description": "Rent a car for your Sangli to Pune journey with ease. Choose from a variety of vehicles, including sedans, SUVs and larger cars, ensuring a comfortable and smooth travel experience."
    },
    {
      "name": "Sangli to Pune Cab Booking",
      "description": "Easily book a Cab from Sangli to Pune through our user-friendly online booking platform. Enjoy timely pickups, well-maintained vehicles and professional drivers, all at competitive rates."
    },
    {
      "name": "Sangli to Pune Road Trip",
      "description": "Planning a road trip from Sangli to Pune? Enjoy a scenic journey with our reliable taxi service, offering comfortable vehicles and experienced drivers to make your road trip unforgettable."
    },
    {
      "name": "Pune Sightseeing by Cab",
      "description": "Discover the best of Pune with our sightseeing Cab service. From historical landmarks to vibrant markets, our experienced drivers will guide you to all the must-see attractions in Pune, ensuring a memorable trip."
    },
    {
      "name": "Sangli to Pune Luxury Taxi",
      "description": "Indulge in a luxury ride from Sangli to Pune with our premium taxi service. Choose from high-end vehicles such as luxury sedans and SUVs, ensuring a plush and comfortable journey."
    }
  ],
  "tableData": [
    ["- Sangli to Pune Taxi", "- Sangli to Pune Cab Service"],
    ["- Sangli to Pune One-Way Taxi", "- Sangli to Pune Round Trip Cab"],
    ["- Affordable Sangli to Pune Cab", "- Private Taxi for Pune from Sangli"],
    ["- Pune Tour from Sangli by Cab", "- Group Travel from Sangli to Pune"],
    ["- Book Sangli to Pune Car", "- Sangli to Pune Cab Booking"],
    ["- Sangli to Pune Road Trip", "- Pune Sightseeing by Cab"],
    ["- Sangli to Pune Luxury Taxi", ""]
  ],


  
  whychoose: [
    {
      "WhyChooseheading": "Comfortable and Relaxing Ride",
      "WhyChoosedescription": "Our Sangli to Pune Cab service offers a comfortable and relaxing ride, ensuring you travel in style with spacious, air-conditioned vehicles. Whether for business or leisure, we make sure your journey is smooth and stress-free with a comfortable atmosphere."
    },
    {
      "WhyChooseheading": "Experienced and Reliable Drivers",
      "WhyChoosedescription": "Our experienced drivers are familiar with the best routes from Sangli to Pune, ensuring your trip is safe and timely. They focus on your comfort, safety and satisfaction, making your ride pleasant and worry-free from start to finish."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We offer affordable and transparent pricing for your Sangli to Pune Cab ride. Our competitive rates come with no hidden fees, ensuring you get the best value for your money. Whether you need a one-way ride or a round trip, we provide budget-friendly options without compromising quality."
    },
    {
      "WhyChooseheading": "Well-Maintained Fleet",
      "WhyChoosedescription": "All our vehicles are regularly serviced and maintained to ensure they are in top condition. Each vehicle is equipped with modern amenities and safety features to provide you with a smooth, reliable and comfortable ride on your journey from Sangli to Pune."
    },
    {
      "WhyChooseheading": "Easy and Quick Booking Process",
      "WhyChoosedescription": "Booking your Sangli to Pune Cab is simple and convenient with SHREE Tours & Travels. You can easily book online via our user-friendly platform, or contact our customer service team for personalized assistance. We ensure a quick and hassle-free booking experience."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for your Sangli to Pune Cab ride. Whether you're traveling in the early morning or late at night, our round-the-clock service ensures that you can book a ride whenever it suits your schedule, giving you flexibility and convenience."
    },
    {
      "WhyChooseheading": "Local Insights and Recommendations",
      "WhyChoosedescription": "Our drivers are not only experienced but also knowledgeable about the local culture, routes and attractions between Sangli and Pune. They can provide useful tips, recommend places to visit and offer insights into the best spots for dining or sightseeing along the way."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, we are dedicated to customer satisfaction. We ensure that your Sangli to Pune Cab ride is comfortable, timely and enjoyable. Our commitment to high-quality service means we guarantee a positive and hassle-free experience for all our customers."
    }
  ]
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  



        
  }
  const faqData = [
    {
        question: "How can I book a Cab from Sangli to Pune?",
        answer: "You can easily book your Sangli to Pune Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Sangli to Pune route?",
        answer: "We offer a variety of vehicles for the Sangli to Pune journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Sangli to Pune inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Sangli to Pune?",
        answer: "Yes, we offer one-way rental options for your Sangli to Pune trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Sangli to Pune trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Sangli to Pune Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Sangli to Pune Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Sangli to Pune trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Sangli to Pune?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Sangli to Pune?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The ride from Sangli to Pune was comfortable and smooth. The driver was experienced and ensured we had a pleasant journey.',
        name: 'Mr. Subhash Jadhav',
    },
    {
        text: 'I had a fantastic experience with SHREE Tours & Travels. The car was well-maintained and the driver was very courteous throughout the trip.',
        name: 'Miss. Aarti Sharma',
    }
];













  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a comfortable and reliable Sangli to Pune Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/sangli-to-pune-cab.jpg",
    "https://shreetoursandtravels.in/img/pune-trip-cab.jpg"
  ],
  "priceRange": "₹2500 - ₹5000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/sangli-to-pune-cab-service",
    "priceCurrency": "INR",
    "price": 3500,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.6,
    "reviewCount": 670
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Shubham Yadav"
      },
      "datePublished": "2024-11-05",
      "reviewBody": "The Cab service from Sangli to Pune was exceptional. Comfortable ride and courteous driver. Highly recommended!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Anjali Patel"
      },
      "datePublished": "2024-11-10",
      "reviewBody": "Excellent experience! The ride was smooth and the car was clean. The driver was very friendly and professional."
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Sangli to Pune Cab Service",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 16.8600,  // Sangli latitude
      "longitude": 74.5600  // Sangli longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/sangli-to-pune-cab-service"
  },
  "keywords": "Sangli to Pune Taxi, Sangli to Pune Cab Service, Sangli to Pune One-Way Taxi, Sangli to Pune Round Trip Cab, Affordable Sangli to Pune Cab, Private Taxi for Pune from Sangli, Pune Tour from Sangli by Cab, Group Travel from Sangli to Pune, Book Sangli to Pune Car, Sangli to Pune Cab Booking, Sangli to Pune Road Trip, Pune Sightseeing by Cab, Sangli to Pune Luxury Taxi"
};




  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Sangli to Pune Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Sangli to Pune Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Sangli to Pune Taxi, Sangli to Pune Cab Service, Sangli to Pune One-Way Taxi, Sangli to Pune Round Trip Cab, Affordable Sangli to Pune Cab, Private Taxi for Pune from Sangli, Pune Tour from Sangli by Cab, Group Travel from Sangli to Pune, Book Sangli to Pune Car, Sangli to Pune Cab Booking, Sangli to Pune Road Trip, Pune Sightseeing by Cab, Sangli to Pune Luxury Taxi" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>
    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/18.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Sanglitopunecab;